let self = null; // Parent class scope context

export default class UpdatePathByConstantValueBehavior {
    constructor(parentContext) {
        self = parentContext;
    }

    updatePath(value) {
        self._currentLen += value;
    }
}


// WEBPACK FOOTER //
// ./src/components/parts/PathMover/Behavior/UpdatePathBehavior/UpdatePathByConstantValueBehavior.js